const docEl = document.documentElement;
let resizeTimer;

function refreshRem() {
    // 页面宽度为 10rem；1920px 视口对应 192px，与 px2rem 的 remUnit 一致。
    const rem = docEl.getBoundingClientRect().width / 10;
    docEl.style.fontSize = `${rem}px`;
    window.rem = rem;
}

function scheduleRefreshRem() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshRem, 300);
}

function setBodyFontSize() {
    document.body.style.fontSize = "12px";
}

// viewport 已设置 initial-scale=1，保持原有 data-dpr 和 body 字号。
docEl.setAttribute("data-dpr", "1");
window.dpr = 1;

if (document.body) {
    setBodyFontSize();
} else {
    document.addEventListener("DOMContentLoaded", setBodyFontSize, { once: true });
}

window.addEventListener("resize", scheduleRefreshRem);
window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
        scheduleRefreshRem();
    }
});

refreshRem();
